import resource from '@/api/report/resource'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  product_categories: [],
  coaCategories: [],
  currencies: [],
  employees: [],
  transactionTypes: [],
  users: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_COA_CATEGORIES(state, data) {
    state.coaCategories = data
  },
  SET_CURRENCIES(state, data) {
    state.currencies = data
  },
  SET_TRANSACTION_TYPES(state, data) {
    state.transactionTypes = data;
  },
  SET_USERS(state, data) {
    state.users = data;
  }
}

export const actions = {
  getBranch(context, attributes = {}) {
    return resource.getBranch({ params: attributes })
  },
  getLocation(context, attributes = {}) {
    return resource.getLocation({ params: attributes })
  },
  getProduct(context, attributes = {}) {
    return resource.getProduct({ params: attributes })
  },
  getProductProfile(context, attributes = {}) {
    return resource.getProductProfile({ params: attributes })
  },
  getCashier(context, attributes = {}) {
    return resource.getCashier({ params: attributes })
  },
  getTransferNumber(context, attributes = {}) {
    return resource.getTransferNumber({
      params: Object.assign(
        {
          filter: {
            date_between: _.join(
              [context.state.date_from, context.state.date_to],
              ','
            ),
            transfer_type: attributes.transfer_type,
            status_id: attributes.status_id
          }
        },
        attributes
      )
    })
  },
  getSerialStatus(context) {
    return resource.serialStatus()
  },
  productCategory(context) {
    return resource.productCategory()
  },
  productProfileLocation(context, attributes = {}) {
    return resource.productProfileLocation({
      params: attributes
    })
  },
  productProfileLocationList(context, attributes = {}) {
    return resource.productProfileLocationList({
      params: attributes
    })
  },
  getEmployee(context) {
    return resource.employee()
  },
  productGroup(context, attributes = {}) {
    return resource.productGroup({ params: attributes })
  },
  getCustomer(context, Options = {}) {
    return resource.getCustomer({ params: Options })
  },
  getVendor(context) {
    return resource.vendorProfile()
  },
  getPaymentMethod(context) {
    return resource.paymentMethod()
  },
  getCustomerType(context) {
    return resource.customerType()
  },
  getCoaSetup(context, attributes = {}) {
    let params = Object.assign({
      filter: {
        search: attributes.search,
        acc_cat_id: attributes.acc_cat_id,
        currency_id: attributes.currency_id
      }
    })
    return resource.coaSetup({ params })
  },
  async getCoaCategory(context, attributes = {}) {
    let response = await resource.coaCategory({ params: attributes })
    context.commit('SET_COA_CATEGORIES', response.data)
  },
  async getCurrency(context, attributes = {}) {
    let response = await resource.currency({ params: attributes })
    context.commit('SET_CURRENCIES', response.data)
  },
  async getTransactionType(context, attributes = {}) {
    let response = await resource.transactionType({ params: attributes });
    context.commit("SET_TRANSACTION_TYPES", response.data);
  },
  getCoaSetup(context, attributes = {}) {
    let params = Object.assign({
      filter: {
        search: attributes.search,
        acc_cat_id: attributes.acc_cat_id,
        currency_id: attributes.currency_id
      }
    });
    return resource.coaSetup({ params });
  },
  async getUserLogin(context, attributes = {}) {
    let response = await resource.userLogin({ params: attributes });
    context.commit("SET_USERS", response.data);
  },
  getSaleContractType(context) {
    return resource.saleContractType()
  },
  getTable(context, Options = {}) {
    return resource.getTable({ params: Options })
  }
}

